import React, { useContext } from "react";
import { Box, GridLegacy as Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IPreferences } from "@/logic/api";
import NotchedCard from "@/components/cards/NotchedCard/NotchedCard";
import { SessionContext } from "@/utility/useSession";
import { isSysAdmin } from "@/utility/utils";
import styles from "../../styles";
import { ShuttlePickupManagementCard } from "./ShuttlePickupManagementCard";

interface ShuttlePickupSettingsProps {
    onSave: (data: Partial<IPreferences>) => Promise<boolean>;
    showFields: boolean;
    showPickupLocationManagement: boolean;
}

export const ShuttlePickupSettings: React.FC<ShuttlePickupSettingsProps> = ({
    onSave,
    showFields,
    showPickupLocationManagement
}) => {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const shouldShowFieldOptions = showFields && isSysAdmin(session);
    const hasVisibleContent = shouldShowFieldOptions || showPickupLocationManagement;
    const useLegacyFieldOptionsLayout = shouldShowFieldOptions && !showPickupLocationManagement;

    if (!hasVisibleContent) {
        return null;
    }

    if (useLegacyFieldOptionsLayout) {
        return (
            <Grid item xs={12}>
                <NotchedCard
                    label={t("settings.shuttlePickup.title")}
                    containerProps={{ "data-testid": "shuttle-pickup-settings-card" }}
                    style={styles.card}
                >
                    <ShuttlePickupManagementCard
                        onSave={onSave}
                        showFields={showFields}
                        showPickupLocationManagement={showPickupLocationManagement}
                        useLegacyFieldOptionsLayout
                    />
                </NotchedCard>
            </Grid>
        );
    }

    return (
        <Grid item xs={12}>
            <NotchedCard
                label={t("settings.shuttlePickup.title")}
                containerProps={{ "data-testid": "shuttle-pickup-settings-card" }}
                style={styles.card}
            >
                <Grid container>
                    <Grid item xs={12}>
                        <Box sx={{ mt: 1 }}>
                            <ShuttlePickupManagementCard
                                onSave={onSave}
                                showFields={showFields}
                                showPickupLocationManagement={showPickupLocationManagement}
                                useLegacyFieldOptionsLayout={useLegacyFieldOptionsLayout}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </NotchedCard>
        </Grid>
    );
};
